<div echarts class="h-100 w-100 d-inline-flex" (chartClick)="onClickCharBar($event)" [options]="option"
    [merge]="option.merge">
</div>